import { ReactNode } from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

type TooltipWrapperProps = {
  text: string;
  children: ReactNode;
};

export default function TooltipWrapper({ text, children }: TooltipWrapperProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className="rounded-lg">{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
